import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { SessionService } from '../../shared/session-service/session.service';
import { ToastrService } from '@kpmg-tax/ui';
import { API_URL } from '../../shared/constants/apiurl-constants';
import { CreateClientUserModel } from '../../shared/models/create-client-user.model';
import { DeleteRequest } from 'src/app/shared/models/user-client/delete-request';
import { role } from 'src/app/shared/constants/role-enum';
import { IDeleteUsersRequest } from '../models/admin-client-user.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class UsersService {
  userData: any;
 public apiUrl: string = environment.webApiDefaultRoot;
 
  constructor(private httpClient: HttpClient,
    public sessionService: SessionService,
    // public dialogService: DialogService,
    public toastrService: ToastrService,
  ) { }

  CreateUser(userData: CreateClientUserModel): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.ADD_USER, userData);
  }

  GetUser(clientId: number): Observable<any> {
    this.userData = this.sessionService.apiUrlGet(
      API_URL.CLIENT.GET_ALL_USER + '?clientId=' + clientId,
    );
    return this.userData;
  }

  deleteUser(clientUserId: number): Observable<any> {
    let deleteClientUserRequest = { clientUserId: clientUserId };
    return this.sessionService.apiUrlPost(API_URL.CLIENT.DELETE_USER, deleteClientUserRequest);
  }
  AddUpdateRole(ClientData: any): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.ADD_UPDATE_ROLE, ClientData);
  }

  updateUserRole(userId: number, roleId: number) {
    const requestBody = { userId: userId, roleId: roleId }
    return this.httpClient.post<boolean>(this.apiUrl + 'Admin/UpdateUserRole', requestBody);
  }

  sendRequestforDeletion(userdata: DeleteRequest[]): Observable<any> {
    return this.sessionService.apiUrlPost(API_URL.CLIENT.DELETE_EMAIL, userdata);
  }

  deleteUsersNew(deleteRequest: IDeleteUsersRequest[]) {
    return this.sessionService.apiUrlDelete(API_URL.DELETE_USERS, deleteRequest);
  }

  deleteUsersFromAD(deleteRequest: IDeleteUsersRequest[]) {
    deleteRequest.forEach(request => {
      forkJoin([this.sessionService.apiUrlDelete(API_URL.DELETE_USERS_FROM_AD, request)]).subscribe(response => {
        console.log('User deleted from AD success', response.toString());
      });
    });
  }

  isClientRoleExists() {
    return this.sessionService.apiUrlGet(API_URL.ISCLIENTROLE_EXISTS);
  }
}
